var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumpminiprogram_con"},[_c('div',{staticClass:"follow-box",style:({
      background: _vm.datas.backColor,
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[_c('div',{staticClass:"follow-info",style:({
        'font-size': _vm.datas.wordSize + 'px',
        'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
        'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
        'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
        color: _vm.datas.wordColor,
      })},[_vm._v(" "+_vm._s(_vm.datas.followDesc)+" ")]),_c('div',{staticClass:"follow-pic"},[((!_vm.datas.appId && !_vm.datas.username) || !_vm.datas.appPath)?_c('img',{staticClass:"btn_con",attrs:{"src":_vm.datas.btnImgUrl || _vm.defaultImg,"alt":""},on:{"click":_vm.handleShowTips}}):_c('wx-open-launch-weapp',{staticStyle:{"width":"100%"},attrs:{"id":"launch-btn","appid":_vm.datas.appId,"username":_vm.datas.username,"path":_vm.datas.appPath},on:{"error":_vm.handleToPageError}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v(" <style> .btn_con { width: 50px; height: 22px; } </style> <div ><img class=\"btn_con\" src=\""+_vm._s(_vm.datas.btnImgUrl || _vm.defaultImg)+"\" alt=\"\" /></div> ")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }